import { Box } from "@mui/material";
import { Dictionary, isNil } from "lodash";
import { DragEvent, MouseEvent, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { setEntranceTracking, setHighlightOverEntrances, setStartingLocations } from "../OotrReducer";
import { useDispatch } from "react-redux";
import { AppState } from "../../core/app/AppReducer";
import BossSelector from "../ennemy/BossSelector";
import { OotItemDto } from "../hints/OotItemAutocomplete";
import KokiriSword from "../../core/assets/oot/gshd/kokiri-sword_32x32.png"
import MasterSword from "../../core/assets/oot/gshd/master-sword_32x32.png"
import { MixPoolPlace, MixpoolType } from "./MixPoolNotes";
import GenericModal from "../../core/components/base/GenericModal";
interface EntranceCheckProps {
  label: string;
  additionalOnCheck?: (value: number) => void;
  hideDoneArea: boolean;
  area: string;
  highlightAreaAccess: string;
  era?: "child" | "adult",
  isOneWay?: true
}

const EntranceCheck = (props: EntranceCheckProps) => {
  //State = 0: not checked, 1: dead/check, 2: overworld entrance, 3: Boss

  let vanillaWarpLogic = useSelector((state: AppState) => state.ui.ootr.main.vanillaWarpLogic)
  let highlightOverEntrance = useSelector((state: AppState) => state.ui.ootr.main.highlightOverEntrances)

  const isBoss = (id: string) => {
    if (
      id?.startsWith("Ghoma") ||
      id?.startsWith("KD") ||
      id?.startsWith("Barinade") ||
      id?.startsWith("PG") ||
      id?.startsWith("Volvagia") ||
      id?.startsWith("Morpha") ||
      id?.startsWith("Bongo") ||
      id?.startsWith("Twinrova")
    )
      return true;
    return false;
  };
  let dispatch = useDispatch();
  let entrances = useSelector(
    (state: AppState) => state.ui.ootr.main.entrances
  );

  useEffect(() => {
    if (isNil(entrances) || !Object.keys(entrances).includes(props.label)) {
      dispatch(
        setEntranceTracking({
          id: props.label,
          state: 0,
          boss: 0,
          destination: "",
          reward: 0,
          era: props.era,
          isOneWay: props.isOneWay
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let entrance = entrances?.[props.label] ?? {
    id: props.label,
    state: 0,
    boss: "",
    destination: "",
    reward: "",
  };

  // const OnClick = () => {
  //   if (isBoss(entrance.id)) return;

  //   setState((entrance.state + 1) % 6);
  // };

  const getStateColor = () => {
    if (isBoss(entrance.id)) return "darkred"; //done

    switch (entrance.state) {
      case 0:
        return "inherit";
      case 5:
        return "darkred"; //done
      case 2:
        return "#B9D9EB"; //overworld
      case 3:
        return "goldenrod"; //Boss
      case 4:
        return "rgba(255, 0, 247, 1)"; //Fairy
      case 1:
        return "rgb(153, 113, 76)"; //important indoor - Scrubs
    }
  };
  const getStateColorRba = () => {
    if (isBoss(entrance.id)) return "rgba(255,0,0,0.3)"; //done
    switch (entrance.state) {
      case 0:
        return "inherit";
      case 1:
        return "rgb(153, 113, 76)"; //important indoor - Scrubs
      case 2:
        return "rgba(108, 180, 238, 0.5)"; //overworld
      case 3:
        return "rgba(192, 135, 2, 0.3)"; //Boss
      case 4:
        return "rgba(246, 136, 255, 0.7)"; //Fairy
      case 5:
        return "rgba(255,0,0,0.3)"; //done
    }
  };
  if (entrance.state === 5 && props.hideDoneArea) return null;

  const setState = (state: number) => {
    if (state === 0) {
      let destinationRemoval = entrance.destination?.split(" => ");

      if (isBoss(destinationRemoval[1]) || isBoss(destinationRemoval[0])) {
        dispatch(
          setEntranceTracking({
            ...entrances[entrance.destination],
            state: 0,
            destination: "",
          })
        );
      } else if (
        destinationRemoval.length === 2 &&
        !entrance.id.includes("=>")
      ) {
        dispatch(
          setEntranceTracking({
            ...entrances[
              destinationRemoval[1] + " => " + destinationRemoval[0]
            ],
            state: 0,
            destination: "",
          })
        );
      } else if (entrances[entrance.destination]?.destination !== "") {
        dispatch(
          setEntranceTracking({
            ...entrances[entrance.destination],
            state: 0,
            destination: "",
          })
        );
      }

      dispatch(
        setEntranceTracking({
          ...entrance,
          state: 0,
          destination: "",
        })
      );
    } else if (state === 2 && !entrance.destination?.includes("=>")) { 

      let link = entrances[entrance.destination];

      if (vanillaWarpLogic && entrance.id.includes("=>")) {
        let splitEntranceId = entrance.id.split(" => ");
        dispatch(
          setEntranceTracking({
            ...link,
            state: 2,
            destination: splitEntranceId === undefined ? "" : splitEntranceId[0] + "("+  splitEntranceId[1] + ")",
          })
        );
      }
      else { // si l'entrance est une OW entrance

        
        dispatch(
          setEntranceTracking({
            ...link,
            state: 2,
            destination:  entrance?.id.split(" ")[0] + " ("+  entrance?.id.split(" ")[1] + ")",
          })
        );
      }
    }
    else if(entrance.destination.split(" ").length < 2){
      dispatch(
      setEntranceTracking({
        ...entrance,
        state: state,
        destination: "",
      })
    );
    }else{

      dispatch(
        setEntranceTracking({
          ...entrance,
          state: state,
          destination: state === 0 ? "" : entrance.destination.split(" ")[0]  + " ("+  entrance.destination.split(" ")[1] + ")",
        })
      );
    }
  };

  const onOver = (e: MouseEvent<HTMLDivElement>) => {
    if(isNil(entrance.destination) || entrance.destination.length === 0)
      return;
    
    var reworkDestination = entrance.destination.replaceAll("(", "").replaceAll(")", "").split(" ");
    let reconstructDestination = "";

    if(Object.keys(entrances).map(x => x.split(" ")[0]).includes(reworkDestination[1].trim()))
      reconstructDestination = reworkDestination[1].trim() + " => " + reworkDestination[0].trim();
    else
      reconstructDestination = reworkDestination[0].trim() + " " + reworkDestination[1].trim();


    let secongHighlight = reconstructDestination.split(" => ");

    if (secongHighlight.length === 2 && !entrance.id.includes("=>")) {

      if(vanillaWarpLogic && reconstructDestination.includes("=>")){
      let destinationSplit = reconstructDestination.split(" => ");

        dispatch(setHighlightOverEntrances([entrance.id, destinationSplit[1] + " => " + destinationSplit[0]]));
      }
      else
      dispatch(setHighlightOverEntrances([entrance.id, reconstructDestination]));

    } else if (entrances[reconstructDestination]?.destination !== "" && !vanillaWarpLogic) {

      dispatch(setHighlightOverEntrances([entrance.id, reconstructDestination]));
      
    } else if (entrances[secongHighlight[1] + " => " + secongHighlight[0]]?.destination !== "" && vanillaWarpLogic){
      
      if(reconstructDestination.includes("=>"))
        dispatch(setHighlightOverEntrances([
          entrance.id,
          secongHighlight[1] + " => " + secongHighlight[0],
        ]));
        else
        {
          dispatch(setHighlightOverEntrances([
            entrance.id,
            reconstructDestination,
          ]));
        }
      
    }
  };
  const onMouseLeave = () => {
    dispatch(setHighlightOverEntrances([]));
  };

  const onDrop = (e: DragEvent<HTMLDivElement>) => {
    let result = e.dataTransfer.getData("text/plain");

    let resultEntrance = entrances[result];



    if (result.startsWith("{")) {
      let parse: OotItemDto = JSON.parse(result);
      dispatch(
        setEntranceTracking({
          ...entrance,
          state: 3,
          boss: Number(parse.name.split(" ")[2]),
        })
      );
    }else if (result.includes("Great Fairy")){
      dispatch(
        setEntranceTracking({ ...entrance, state: 4, destination: "Great Fairy" })
      );
    } else if (result.startsWith("IMPORTANT")) {
      dispatch(
        setEntranceTracking({
          ...entrance,
          state: 1,
          destination: result.replace("IMPORTANT", ""),
        })
      );
    } else if (resultEntrance?.isOneWay) {

      let oneWayEntrance = entrances[result];

      let resultSplit = entrance.id.split(" => ");
      if(resultSplit.length !== 2)
        resultSplit = entrance.id.split(" ")

      dispatch(
        setEntranceTracking({
          ...oneWayEntrance,
          state: 2,
          destination: resultSplit[0] + " (" + resultSplit[1] + ")",
        })
      );
    } 
    else if (result.includes("Scrubs"))
      dispatch(
        setEntranceTracking({ ...entrance, state: 1, destination: result })
      );
    else {
      let spliter = " => "
      if(!result.includes(spliter))
        spliter = " "
      let resultSplit = result.split(spliter);
      let coupleEntrance = entrances[result];

      if (vanillaWarpLogic) {  //Vanilla Warp logic enable

        //reverse destination way
        dispatch(
          setEntranceTracking({
            ...entrance,
            state: 2,
            destination: resultSplit[0] + " (" + resultSplit[1] + ")",
          })
        );

        if (entrance.id.includes(" => ")) { //if vanilla logic warp enable and entrance is an overworld warp, reverse it for the new destination
          let coupleEntranceDestinationSplit = entrance.id.split(spliter);
          dispatch(
            setEntranceTracking({
              ...coupleEntrance,
              state: 2,
              destination: coupleEntranceDestinationSplit[0] + " (" +
                coupleEntranceDestinationSplit[1] + ")"
                ,
            })
          );
        } else {
          dispatch(
            setEntranceTracking({
              ...coupleEntrance,
              state: 2,
              destination: entrance.id.split(" ")[0] + " (" + entrance.id.split(" ")[1]+")",
            })
          );
        }
      } else {
        dispatch(
          setEntranceTracking({ ...entrance, state: 2, destination: result })
        );
        dispatch(
          setEntranceTracking({
            ...coupleEntrance,
            state: 2,
            destination: entrance.id,
          })
        );
      }
    } 
  };

  
  return (
    <Box
      className={
        ((!vanillaWarpLogic &&
          entrance.destination.startsWith(props.highlightAreaAccess)) ||
          (vanillaWarpLogic &&
            ((entrance.destination.endsWith(props.highlightAreaAccess) && entrance.destination.includes("=>")) || (entrance.destination.startsWith(props.highlightAreaAccess) && !entrance.destination.includes("=>"))))) &&
        props.highlightAreaAccess.length > 0
          ? "highlight-area-access"
          : highlightOverEntrance?.includes(entrance.id)
          ? "highlight-entrance"
          : entrance.state === 3
          ? "entrance-boss"
          : ""
      }
      id={entrance.id}
      display={"flex"}
      paddingLeft={"5px"}
      paddingRight={"5px"}
      paddingBottom={"2px"}
      alignItems={"center"}
      justifyContent={"center"}
      textAlign={"center"}
      onMouseOver={(e) => onOver(e)}
      onMouseLeave={onMouseLeave}
      // onClick={(e) => {
      //   if (e.ctrlKey || e.altKey) {
      //     if (entrance.state === 5) return;
      //     if (!isNil(props.additionalOnCheck)) props.additionalOnCheck(5);
      //     setState(5);
      //   } else {
      //     OnClick();

      //     if (!isNil(props.additionalOnCheck))
      //       props.additionalOnCheck((entrance.state + 1) % 5);
      //   }
      // }}
      onDoubleClick={(e) => {
        setState(5);
        if (!isNil(props.additionalOnCheck))
          props.additionalOnCheck(5);
      }}
      onContextMenu={(e) => {
        e.preventDefault();
        if (!isNil(props.additionalOnCheck)) props.additionalOnCheck(0);
        setState(0);
      }}
      sx={{
        textDecoration:
          entrance.state === 5 || isBoss(entrance.id) ? "line-through" : "none",
        textDecorationColor: getStateColor(),
        // color: getStateColor(),
        backgroundColor: getStateColorRba(),
        borderRadius: "25px",
      }}
      position={"relative"}
      onDragOver={(e) => {
        e.preventDefault();
      }}
      onDragEnter={(e) => {
        e.preventDefault();
      }}
      onDrop={(e) => onDrop(e)}
      width={"150px"}
      height={"27px"}
    >
      <Box
        marginTop={entrance.destination.length === 0 ? "0px" : "-8px"}
        draggable
        onDragStart={(e) => {
          e.dataTransfer.setData("text/plain", props.label);
        }}
        onDragOver={(e) => {
          e.preventDefault();
        }}
        sx={{ fontSize: props.label.length > 13 ? "12px" : "16px" }}
      >
        {/* {props.label.replace(props.area, "")} */}
        {props.label}
      </Box>
      {entrance.state === 3 && (
        <BossSelector
          value={entrance.boss}
          additionalOnCheck={(img) => {
            dispatch(setEntranceTracking({ ...entrance, boss: img }));
          }}
        />
      )}
      {!isNil(entrance.destination) && entrance.state !== 3 && (
        <Box
          sx={{
            color: GetAreaColor(entrance.destination.split(" ")[0]),
            fontSize: entrance.destination.length > 13 ? "9px" : "11px" ,
          }}
          position="absolute"
          top="13px"
          zIndex={99}
        >
          {entrance.destination}
        </Box>
      )}
    </Box>
  );
};

export const GetAreaColor = (name: string) => {
  if (["ZF", "ZD", "ZR", "LH", "Water", "Jabu", "Ice"].includes(name))
    return "lightblue";

  if (["KF", "LW", "SFM", "LW_Bridge", "Forest", "Deku"].includes(name))
    return "lightgreen";

  if (["GY", "KAK", "Shadow", "Botw", "KAK_Potion"].includes(name))
    return "rgb(162, 64, 204)";

  if (["GV", "GF", "Wasteland", "Coloss", "Spirit", "GTG"].includes(name))
    return "orange";

  if (["DMT", "DMC", "GC", "Fire", "DC"].includes(name)) return "#841617";

  if (["MKT", "HC", "HF", "LLR", "MKT_Bridge", "OGC", "Ganon_Castle", "Out_ToT"].includes(name))
    return "yellow";

  return "inherit";
};

export const GetAreaColorRgba = (name: string) => {
  if (["ZF", "ZD", "ZR", "LH", "Water", "Jabu", "Ice"].includes(name))
    return "rgba(100,100,255, 0.1)";

  if (["KF", "LW", "SFM", "LW_Bridge", "Forest", "Deku"].includes(name))
    return "rgba(100,255,100, 0.15)";

  if (["GY", "KAK", "Shadow", "BotW", "Kak_Potion"].includes(name))
    return "rgba(220, 160, 250, 0.4)";

  if (["GV", "GF", "Wasteland", "Coloss", "Spirit", "GTG"].includes(name))
    return "rgba(200,100,2,0.2)";

  if (["DMT", "DMC", "GC", "Fire", "DC"].includes(name))
    return "rgba(255,100,100,0.15)";

  if (["MKT", "HC", "HF", "LLR", "MKT_Bridge", "OGC", "Ganon_Castle", "Out_ToT"].includes(name))
    return "rgba(200,255,50,0.2)";

  return "inherit";
};

export default EntranceCheck;

interface AreaEntranceCheckProps {
  values: Dictionary<MixPoolPlace[]>;
  areaName: string;
  hideAreaDone: boolean;
  hideEntranceLeft: boolean;
  highlightAreaAccess: string;
  setHighlightAreaAccesss: (v: string) => void;
  areaToDisplay: Array<MixpoolType>
  widthEnhanced?: boolean
}

const getDungeonArea = (dungeon: string) => {
  if (isNil(dungeon)) return "";
  if (dungeon.startsWith("Deku") || dungeon.startsWith("Ghoma")) return "KF";
  if (dungeon.startsWith("DC") || dungeon.startsWith("KD")) return "DMT";
  if (dungeon.startsWith("Jabu") || dungeon.startsWith("Barinade")) return "ZF";
  if (dungeon.startsWith("Forest") || dungeon.startsWith("PG")) return "SFM";
  if (dungeon.startsWith("Fire") || dungeon.startsWith("Volvagia"))
    return "DMC";
  if (dungeon.startsWith("Water") || dungeon.startsWith("Morpha")) return "LH";
  if (dungeon.startsWith("Shadow") || dungeon.startsWith("Bongo")) return "GY";
  if (dungeon.startsWith("Spirit") || dungeon.startsWith("Twinrova"))
    return "Coloss";
};
export const AreaEntranceCheck = (props: AreaEntranceCheckProps) => {

  let {values: initialValues, areaName }= props

  let values = initialValues[areaName as any];

  let entrances = useSelector(
    (state: AppState) => state.ui.ootr.main.entrances
  );

  let startingLocations = useSelector(
    (state: AppState) => state.ui.ootr.main.accessibleStartingLocation
  );

  let dispatch = useDispatch();

  let entranceArea = Object.entries(entrances).filter(
    (x) =>
      x[1].id?.startsWith(props.areaName) ||
      getDungeonArea(x[1].id) === props.areaName
  );
  let nbAreaLeft = 0;

  let [modalPathingOpen, setModalPathingOpen] = useState(false);
  let [modalAreaValue, setModalAreaValue] = useState(areaName);

  if (entranceArea.length > 0)
    nbAreaLeft = entranceArea.filter((x) => x[1].state === 0).length;

  const onDropSongOrItem = (e: DragEvent<HTMLDivElement>) => {
    let dropValue = e.dataTransfer.getData("text/plain");

    const item: OotItemDto = JSON.parse(dropValue);

    dispatch(setStartingLocations([...startingLocations?.filter(x => x.id !== item.name), {id: item.name, img: item.img, item: item, area: props.areaName}]))
  };

  let song = startingLocations?.filter(x => x.area === props.areaName && !x.id.includes("Sword") && !x.id.includes("Owl"))?.[0];
  let owl = startingLocations?.filter(x => x.area === props.areaName &&  x.id.includes("Owl"))?.[0];

  return (
    <Box
      display={"flex"}
      justifyContent={"flex-start"}
      sx={{ backgroundColor: GetAreaColorRgba(props.areaName) }}
      // maxWidth={"700px"}
    >
      <Box
        fontWeight={"bold"}
        minWidth={"180px"}
        display={"flex"}
        flexDirection={"row"}
        justifyContent={"space-between"}
        alignContent={"center"}
        sx={{
          color: nbAreaLeft === 0 ? "goldenrod" : GetAreaColor(props.areaName),
          borderTop: "dotted 1px " + GetAreaColor(props.areaName),
          fontSize: "14px",
        }}
        alignItems={"center"}
        borderRight={"1px solid"}
        onDrop={onDropSongOrItem}
        onContextMenu={(e) => {
          e.preventDefault();
        }}
      >
          <GenericModal open={modalPathingOpen} handleClose={(v) => setModalPathingOpen(false)} width={1000}>
            <Box><h2>Vous êtes à {modalAreaValue}</h2></Box>
              <Box display={"flex"} flexDirection={"column"}>
                {Object.values(entrances).flatMap(x => x).filter(x => x.destination.startsWith(modalAreaValue)).map(x => {

                  if(x.id?.includes(" => "))
                    return <Box display={"flex"}  onClick={() => {setModalAreaValue(x.id?.split(" ")[0])}}>
                      <Box width={"100px"}>via {x.destination.replace(areaName, "").replace("(", "").replace(")", "").replace(" => ", " ( ") }</Box>
                      <Box>leads to</Box>
                      <Box marginLeft={"15px"} sx={{color: GetAreaColor(x.id?.split(" ")[0])}}>{x.id?.replace(areaName, "").replace(" => ", " ( ") + " )"}</Box>
                    </Box>
                  else
                    return <Box display={"flex"} onClick={() => {setModalAreaValue(x.id?.split(" ")[0])}}>
                    <Box width={"100px"}>via {x.destination?.replace(areaName, "").replace("(", "").replace(")", "").replace(" => ", " ( ") }</Box>
                    <Box>leads to</Box>
                    <Box marginLeft={"15px"} sx={{color: GetAreaColor(x.id?.split(" ")[0])}} >
                      {x.id?.replace(areaName, "").replace(" => ", "( ") + " )"}
                      </Box>
                  </Box>
                })}
              </Box>
          </GenericModal>
        <Box
          position={"absolute"}
          minWidth={"180px"}
          draggable
          onDragStart={(e) => {
            e.dataTransfer.setData("text/plain", props.areaName);
          }}
          onDragOver={(e) => {
            e.preventDefault();
          }}
          onMouseOver={(e) => {
            props.setHighlightAreaAccesss(props.areaName);
          }}
          onMouseLeave={(e) => {
            props.setHighlightAreaAccesss("");
          }}
          onClick={() => {setModalPathingOpen(true)} }
        >
          {props.areaName} 
        </Box>{" "}
        {!props.hideEntranceLeft && (
          <Box width={"100%"} textAlign={"center"}>
            {nbAreaLeft !== 0 ? nbAreaLeft : ""}
          </Box>
        )}
        <Box display={"flex"} >
          {startingLocations?.some(x => x.area === props.areaName && x.id === "Kokiri Sword") && (
            <Box
              zIndex={999}
              onContextMenu={(e) => {
                e.preventDefault();
                dispatch(setStartingLocations([...startingLocations.filter(x => x.id !==  "Kokiri Sword")]))
              }}
            >
              <img src={KokiriSword} alt="age" width={32} height={32} />
            </Box>
          )}
          {startingLocations?.some(x => x.area === props.areaName && x.id === "Master Sword") && (
            <Box
              zIndex={999}
              onContextMenu={(e) => {
                e.preventDefault();
                dispatch(setStartingLocations([...startingLocations?.filter(x => x.id !==  "Master Sword")]))
              }}
            >
              <img src={MasterSword} alt="age" width={32} height={32} />
            </Box>
          )}
          {!isNil(song) && (
            <Box
              zIndex={999}
              onContextMenu={(e) => {
                e.preventDefault();
                dispatch(setStartingLocations([...startingLocations?.filter(x => x.id !== song.id)]))
              }}
            >
              <img src={song.img} alt="song" width={32} height={32} />
            </Box>
          )}
          {!isNil(owl) && (
            <Box
              zIndex={999}
              onContextMenu={(e) => {
                e.preventDefault();
                dispatch(setStartingLocations([...startingLocations?.filter(x => x.id !== owl.id)]))
              }}
            >
              <img src={owl.img} alt="owl" width={32} height={32} />
            </Box>
          )}
        </Box>
      </Box>
      {values.filter(x => x.type === "interior" ).length > 0 && <Box id="mixpool-interrior" display={"flex"} flexDirection={"row"} flexWrap={"wrap"} width={props.widthEnhanced ? 700 : 500} margin={"0px"} borderRight={"1px black solid"} borderBottom={"1px black dashed"}>
        {values.filter(x => x.type === "interior"  ).map((x) => {
          return (
            <EntranceCheck
              hideDoneArea={props.hideAreaDone}
              label={x.name}
              area={props.areaName}
              highlightAreaAccess={props.highlightAreaAccess}
              era={x.eraRestricted}
              isOneWay={x.isOneWay}
            />
          );
        })}
      </Box>}
      {values.filter(x => x.type === "interior" ).length === 0 && props.areaToDisplay.includes("interior") && <Box id="mixpool-interrior" display={"flex"} flexDirection={"row"} flexWrap={"wrap"} width={props.widthEnhanced ? 700 : 500} margin={"0px"} borderRight={"1px black solid"} borderBottom={"1px black dashed"}/>}
      
      {values.filter(x => x.type === "grotto").length > 0 && <Box id="mixpool-grotto" display={"flex"} flexDirection={"row"} flexWrap={"wrap"} width={props.widthEnhanced ? 700 : 500}  margin={"0px"} borderRight={"1px black solid"} borderBottom={"1px black dashed"}>
        {values.filter(x => x.type === "grotto").map((x) => {
          return (
            <EntranceCheck
              hideDoneArea={props.hideAreaDone}
              label={x.name}
              area={props.areaName}
              highlightAreaAccess={props.highlightAreaAccess}
              era={x.eraRestricted}
              isOneWay={x.isOneWay}
            />
          );
        })}
      </Box>}
      {values.filter(x => x.type === "grotto").length === 0 && props.areaToDisplay.includes("grotto") && <Box id="mixpool-grotto" display={"flex"} flexDirection={"row"} flexWrap={"wrap"} width={props.widthEnhanced ? 700 : 500}   margin={"0px"} borderRight={"1px black solid"} borderBottom={"1px black dashed"} />}

      {values.filter(x => (x.type === "overworld" && props.areaToDisplay.includes("overworld")) ||  (x.type === "dungeon_entrance" && props.areaToDisplay.includes("dungeon_entrance")) || (x.type === "dungeon" && props.areaToDisplay.includes("dungeon"))).length > 0 && 
      
      <Box id="mixpool-overworld" display={"flex"} flexDirection={"row"} width={props.widthEnhanced ? 700 : 500}  flexWrap={"wrap"}   margin={"0px"} borderRight={"1px black solid"} borderBottom={"1px black dashed"}>
        {values.filter(x => (x.type === "overworld" && props.areaToDisplay.includes("overworld")) ||  (x.type === "dungeon_entrance" && props.areaToDisplay.includes("dungeon_entrance")) || (x.type === "dungeon" && props.areaToDisplay.includes("dungeon"))).map((x) => {
          return (
            <EntranceCheck
              hideDoneArea={props.hideAreaDone}
              label={x.name}
              area={props.areaName}
              highlightAreaAccess={props.highlightAreaAccess}
              era={x.eraRestricted}
              isOneWay={x.isOneWay}
            />
          );
        })}
      </Box>}
      {values.filter(x => (x.type === "overworld" && props.areaToDisplay.includes("overworld")) ||  (x.type === "dungeon_entrance" && props.areaToDisplay.includes("dungeon_entrance")) || (x.type === "dungeon" && props.areaToDisplay.includes("dungeon"))).length === 0  && <Box id="mixpool-overworld" display={"flex"} flexDirection={"row"} flexWrap={"wrap"} width={props.widthEnhanced ? 700 : 500}   margin={"0px"} borderRight={"1px black solid"} borderBottom={"1px black dashed"}/>}
      
     
    
    </Box>
  );
};
